"use client"
import { cn } from "@/lib/utils"
import { ArrowLeft01Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { useRouter } from "next/navigation"

export const BackButton = ({
  className,
  onClick,
}: {
  className?: string
  onClick?: () => void
}) => {
  const router = useRouter()
  return (
    <div
      className={cn(
        "p-[0.45rem] md:p-[0.65rem] cursor-pointer bg-white md:bg-transparent rounded-full border border-[#C9C9C9]",
        className
      )}
      onClick={() => {
        if (onClick) {
          onClick?.()
        } else {
          router.back()
        }
      }}
    >
      <HugeiconsIcon
        icon={ArrowLeft01Icon}
        className="size-4 md:size-4"
        strokeWidth={1.8}
      />
    </div>
  )
}
